import React from 'react';
import {Switch, Tooltip, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import styles from './accountResources.module.scss';

export default function AccountResources({formik}){
    const {t} = useTranslation();

    const modulesConfig = [
        {key: 'climateCheck', label: 'ACCOUNTS_PAGE.CLIMATE_CHECK'},
        {key: 'evaluation', label: 'ACCOUNTS_PAGE.EVALUATION'},
        {key: 'tasks', label: 'ACCOUNTS_PAGE.TASKS'},
        {key: 'training', label: 'ACCOUNTS_PAGE.TRAINING'},
    ];
    
    return (
        <div className={styles.container}>
            {modulesConfig.map(({key, label}) => {
                const isEnabled = formik.values.modules?.[key];
                const toggleLabel = isEnabled ? t('ACCOUNTS_PAGE.ENABLED')  : t('ACCOUNTS_PAGE.DISABLED');

                return (
                    <div key={key}>
                        <div className={styles.row}>
                            <Typography variant='h6' component='h6' mt={3} mb={1}>
                                {t(label)}
                            </Typography>
                        </div>
                        <div className={styles.item}>
                            <Tooltip title={toggleLabel}>
                                <Switch 
                                    onChange={() => formik.setFieldValue(`modules.${key}`, !formik.values?.modules[key])}
                                    name={`modules.${key}`}
                                    checked={formik?.values?.modules[key]}
                                    formik={formik}
                    />
                            </Tooltip>
                            <div>
                                {toggleLabel}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
